import React, { Component } from 'react'
import HeaderIndicator from 'modules/Indicators/Header/HeaderIndicator'
import Config from 'utils/config'

class HeaderIndicatorsContainer extends Component {
  render() {
    const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : ''
    return (
      <React.Fragment>
        <HeaderIndicator
          key={'PIB per capita'}
          indicator={Config.getConfig().header.indicators[0]}
          selectedRegionId={this.props.selectedRegionId}
          imgPath={BASE_URL + '/img/icono-pib-per-capita.svg?v=02'}
        />
        <HeaderIndicator
          key={'Población total'}
          indicator={Config.getConfig().header.indicators[1]}
          selectedRegionId={this.props.selectedRegionId}
          imgPath={BASE_URL + '/img/icono-poblacion.svg?v=02'}
        />
        <HeaderIndicator
          key={'Tasa de desempleo'}
          indicator={Config.getConfig().header.indicators[2]}
          selectedRegionId={this.props.selectedRegionId}
          imgPath={BASE_URL + '/img/icono-desempleo.svg?v=02'}
        />
      </React.Fragment>
    )
  }
}

export default HeaderIndicatorsContainer



// WEBPACK FOOTER //
// ./src/modules/Indicators/Header/HeaderIndicatorsContainer/HeaderIndicatorsContainer.jsx